import { graphql } from "react-relay";

export const PAGE_FRAGMENT = graphql`
	fragment textWithPagesElementPageFormDialog_PageFragment on TextWithPagesPage {
		internalTitle
		...textWithPagesElementPageForm_TextWithPagesPageFragment
	}
`;
